require('./loanModifyAssociatedAccountStep2.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
//@ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getFormattedString } = require('utilities/currencyHelper');
const { getLastNChars } = require('utilities/stringHelper');
//@ components
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const LoanCollectiveTag = require('../../loanCollectiveTag/loanCollectiveTag');
// @ constants
const { LOAN_MODIFY_ASSOCIATED_ACCOUNT } = require('constants/operationTypes');
const { API_CENTER, API_ENTERPRISE_NUMBER } = require('constants/index');

class LoanModifyAssociatedAccountStep2 extends React.PureComponent {
    buildAccountInformativeList(immAccount) {
        const accountType = immAccount.getIn(['catalogData', 'product']);
        const formattedIban = getLastNChars(immAccount.get('iban'));
        const accountBalance = getFormattedString(immAccount.get('balance'));

        return (
            <OKInformativeList columns={3}>
                <OKInformativeListItem
                    title={formatText('loanModifyAssociatedAccount-firstStepOwner')}
                    bodyWordBreak={false}
                    bodyText={immAccount.get('accountHolder')}
                />
                <OKInformativeListItem
                    title={immAccount.get('alias')}
                    bodyText={`${accountType} ${formattedIban}`}
                />
                <OKInformativeListItem
                    title={formatText('loanModifyAssociatedAccount-firstStepBalance')}
                    bodyText={accountBalance}
                />
            </OKInformativeList>
        );
    }

    buildBadge() {
        const { immLoan } = this.props;

        return (
            <LoanCollectiveTag
                extraClass="loan-modify-associated-account-step-two__collective-tag"
                immLoan={immLoan}
            />
        )
    }

    render() {
        const { immLoan, immCurrentAccount, immNewAccount } = this.props;
        const currentAccountItems = this.buildAccountInformativeList(immCurrentAccount);
        const newAccountItems = this.buildAccountInformativeList(immNewAccount);
        const badge = this.buildBadge();
        const apiPrefix = API_ENTERPRISE_NUMBER + API_CENTER;

        //Don't use account.getIn(['ibanComplex','codbban']). It has a control digit that breaks signature pattern.
        const operationParams = {
            originAccount: apiPrefix + immLoan.get('product') + immLoan.get('contractNumber'),
            destinationAccount: apiPrefix + immNewAccount.get('product') + immNewAccount.get('contractNumber')
        };

        return (
            <div className="loan-modify-associated-account-step-two">
                <header className="loan-modify-associated-account-step-two__header">
                    <FormattedText value="loanModifyAssociatedAccount-secondStepTitle" className="loan-modify-associated-account-step-two__title" />
                    {badge}
                </header>
                <article className="loan-modify-associated-account-step-two__content">
                    <FormattedText value="loanModifyAssociatedAccount-secondStepSubtitle" className="loan-modify-associated-account-step-two__subtitle" />
                    <FormattedText value="loanModifyAssociatedAccount-secondStepCurrentAccount" className="loan-modify-associated-account-step-two__label" />
                    {currentAccountItems}
                    <FormattedText value="loanModifyAssociatedAccount-secondStepNewAccount" className="loan-modify-associated-account-step-two__label" />
                    {newAccountItems}
                </article>
                <SignaturePattern
                    operationType={LOAN_MODIFY_ASSOCIATED_ACCOUNT}
                    operationParams={operationParams}
                />
            </div>
        );
    }
}

LoanModifyAssociatedAccountStep2.propTypes = {
    immCurrentAccount: PropTypes.object.isRequired,
    immLoan: PropTypes.object.isRequired,
    immNewAccount: PropTypes.object
};

module.exports = LoanModifyAssociatedAccountStep2;
